define('services/analytics/analyticsCalculations',[
    'lib/knockout',
    'lib/lodash4',

    'services/analyticsService'
], function (
    ko,
    _,

    analyticsService
) {
    'use strict';

    var analyticsCalulcations = {
        computeAbandonRate: function (analyticsData) {
            var data = ko.unwrap(analyticsData);

            if (!data) {
                return null;
            }

            var abandoned = data.sumCount(analyticsService.STAT_KEYS.ABANDONED);
            var offered = data.sumCount(analyticsService.STAT_KEYS.OFFERED);

            // Abandon Rate = Abandon / Offer * 100%

            if (_.isNull(offered) || offered === 0) {
                // don't divide by 0
                 return null;
            }

            if (_.isNull(abandoned)) {
                abandoned = 0;
            }

            var abandonRate = abandoned / offered;

            return abandonRate;
        },

        computeServiceLevel: function (analyticsData) {
            var data = ko.unwrap(analyticsData);

            if (!data) {
                return null;
            }

            var numerator = data.sumMetricAttribute(analyticsService.STAT_KEYS.SERVICE_LEVEL, "numerator");
            var denominator = data.sumMetricAttribute(analyticsService.STAT_KEYS.SERVICE_LEVEL, "denominator");

            if (_.isNull(denominator) || denominator === 0) {
                return null;
            }

            if (_.isNull(numerator)) {
                numerator = 0;
            }

            return numerator / denominator;
        },

        getServiceLevelTarget: function (analyticsData) {
            var data = ko.unwrap(analyticsData);

            if (!data) {
                return null;
            }

            var target = data.avgMetricAttribute(analyticsService.STAT_KEYS.SERVICE_TARGET, "current");

            if (_.isNull(target)) {
                return null;
            }
            return target;
        }
    };

    return analyticsCalulcations;
});

